/**
 * Created by Pavel on 14.11.14.
 *
 * Show html in popup after loading
 */
define([
    'jQuery',
    'underscore',
    'library/fcse-compatibility/object',
    'clientComponents/request/multiRequestHandlerExtended',
    'library/fcse-component/optionsMixin',
    'simplemodal'
    ],
    function($, _, Object, MultiRequestHandler, OptionsMixin) {
        var requestHandler = new MultiRequestHandler(),
            AjaxContentLoader =  function(selector, scope, options) {
                this.selector = selector;
                this.scope = scope;
                // Set default options
                var defaultOptions = {
                    name: 'hotelId',
                    routeAttribute: 'data-route',
                    idAttribute: 'data-hotel-id',
                    departureDate: !_.isUndefined(productSearchParams) && productSearchParams['departureDate'] ? productSearchParams['departureDate'] : ''
                };
                this.addOptions(defaultOptions, options);
                this._init();
            };
        AjaxContentLoader.prototype = $.extend(Object.create(OptionsMixin), {
            _init: function() {
                this._initEvents();
                this._initLoadingEvents();
            },
            _initEvents: function() {
                $(document).on('click', this.selector, $.proxy(this._clickHandler, this));
            },
            _clickHandler: function(event) {
                var target = $(event.target),
                    idAttr = this.option('idAttribute'),
                    routeAttr = this.option('routeAttribute'),
                    name = this.option('name'),
                    element = target.is('['+idAttr+']')?target:target.closest('[' + idAttr + ']'),
                    value = element.attr(idAttr),
                    route = element.attr(routeAttr),
                    lightboxNode = $('[data-fcse-role="modal"]', element),
                    loadedNode = $('[data-fcse-role="modal"][data-loaded][data-'+name+'='+value+']'),
                    options = $.extend({}, this.scope.getQuery()),
                    currentTarget = $(event.currentTarget),
                    extraOptions = currentTarget.data('extra-options');

                options[name] = value;

                if (_.isObject(extraOptions)) {
                    _.extend(options, extraOptions);
                }

                if (!_.isObject(extraOptions) && (typeof(options['departureDate']) == 'undefined' || options['departureDate'] == '')) {
                    options['departureDate'] = this.option('departureDate');
                }
                if (loadedNode.length > 0) {
                    this._showLightBox(loadedNode);
                    return;
                }
                lightboxNode.modal();
                requestHandler.send(route, options, options, {
                    name: name,
                    value: value,
                    element: element,
                    lightBox: lightboxNode
                });
            },
            _initLoadingEvents: function() {
                requestHandler.on('success', $.proxy(this._onLoadContentSuccess, this));
            },
            /**
             * Handler for content loading success
             * @param event
             * @param data
             * @private
             */
            _onLoadContentSuccess: function(event, data){
                var element = data.options.element,
                    lightbox = data.options.lightBox,
                    name = data.options.name,
                    value = data.options.value;
                if ($(element, this.element).length > 0) {
                    if (lightbox.closest('html').length === 0) {
                        return;
                    }
                    if ($.modal) {
                        $.modal.close();
                    }
                    lightbox.remove();
                    element.append(event.html);
                    lightbox = $('[data-fcse-role="modal"][data-loaded]', element);
                    lightbox.attr('data-'+name, value);
                    this._showLightBox(lightbox);
                }
            },
            /**
             * Show lightbox
             * @param {jQueryElement} lightboxNode
             */
            _showLightBox: function(lightboxNode) {
                var onshow = this.option('onshow');
                lightboxNode.modal();
                if (_.isFunction(onshow)) {
                    onshow(lightboxNode);
                }
            }
        });

        return AjaxContentLoader;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/ajaxcontentloader/ajaxContentLoader.js